import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-left.svg'
import _imports_1 from '@/app/ui/assets/svg/exclamation-circle-solid.svg'


const _hoisted_1 = { class: "flex flex-row justify-between items-center border-b border-gray-lp-400 font-montserrat mt-2 md:mt-0 lg:mt-0 xl:mt-0 xxl:mt-0" }
const _hoisted_2 = { class: "flex flex-row my-4" }
const _hoisted_3 = { class: "font-semibold text-14px lg:text-20px xl:text-20px xxl:text-20px mr-4 text-black-lp-200" }
const _hoisted_4 = {
  key: 0,
  class: "inline-flex"
}
const _hoisted_5 = { class: "text-white bg-gray-lp-600 px-6 lg:px-8 xl:px-8 xxl:px-8 text-12px xxl:text-14px py-1.5 lg:py-2 xl:py-2 xxl:py-3 font-bold rounded-md focus:outline-none" }
const _hoisted_6 = {
  key: 1,
  class: "inline-flex"
}
const _hoisted_7 = { class: "flex flex-row h-screen py-6 overflow-y-auto" }
const _hoisted_8 = { class: "w-full lg:w-4/5 px-4 text-12px xxl:text-14px" }
const _hoisted_9 = { class: "grid grid-cols-1 md:grid-cols-3 gap-3 mb-0" }
const _hoisted_10 = { class: "w-full py-3" }
const _hoisted_11 = { class: "font-semibold text-black-lp-300 pb-2" }
const _hoisted_12 = { class: "w-full py-3" }
const _hoisted_13 = { class: "font-semibold text-black-lp-300 pb-2" }
const _hoisted_14 = { class: "w-full py-3" }
const _hoisted_15 = { class: "font-semibold text-black-lp-300 w-full pb-2" }
const _hoisted_16 = { class: "w-full py-3" }
const _hoisted_17 = { class: "font-semibold text-black-lp-300 pb-2" }
const _hoisted_18 = { class: "w-full py-3" }
const _hoisted_19 = { class: "font-semibold text-black-lp-300 w-full pb-2" }
const _hoisted_20 = {
  key: 0,
  class: "w-full py-3"
}
const _hoisted_21 = { class: "font-semibold text-black-lp-300 w-full pb-2" }
const _hoisted_22 = { class: "py-3 w-full md:w-3/4" }
const _hoisted_23 = { class: "font-semibold text-black-lp-300" }
const _hoisted_24 = { class: "flex flex-col gap-y-1" }
const _hoisted_25 = { class: "flex items-end w-full" }
const _hoisted_26 = { class: "inline-block relative w-full" }
const _hoisted_27 = { class: "pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700" }
const _hoisted_28 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-5 mr-3",
  alt: "warning"
}, null, -1)
const _hoisted_29 = {
  key: 0,
  class: "text-2xl font-semibold text-black-lp-300 ml-2"
}
const _hoisted_30 = { class: "text-gray-lp-600 text-xs list-disc pl-4" }
const _hoisted_31 = { class: "font-semibold" }
const _hoisted_32 = { class: "flex flex-col w-full md:flex-row md:w-3/4" }
const _hoisted_33 = { class: "font-semibold text-black-lp-300" }
const _hoisted_34 = { class: "inline-block relative w-full" }
const _hoisted_35 = { class: "pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700" }
const _hoisted_36 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-5 mr-3",
  alt: "warning"
}, null, -1)
const _hoisted_37 = {
  key: 0,
  class: "text-red-lp-100 text-12px xxl:text-14px whitespace-no-wrap"
}
const _hoisted_38 = {
  key: 1,
  class: "flex gap-2 justify-start items-center"
}
const _hoisted_39 = { class: "text-red-lp-100 text-12px xxl:text-14px whitespace-no-wrap" }
const _hoisted_40 = { class: "font-semibold text-black-lp-300" }
const _hoisted_41 = {
  key: 0,
  class: "w-full py-3 md:w-1/3"
}
const _hoisted_42 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Negara HQ", -1)
const _hoisted_43 = { class: "flex items-center gap-x-2 w-full" }
const _hoisted_44 = { class: "text-14px font-medium text-gray-lp-300" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_Select = _resolveComponent("Select")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_MultipleSelectSearch = _resolveComponent("MultipleSelectSearch")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_SelectPhoneCountry = _resolveComponent("SelectPhoneCountry")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("img", {
          src: _imports_0,
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
          class: "w-5 mr-3 cursor-pointer",
          alt: "back"
        }),
        _createVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("userManagement.add.title")), 1)
      ]),
      (!_ctx.isFormValid)
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            _createVNode("button", _hoisted_5, _toDisplayString(_ctx.$t("userManagement.add.save")), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.isFormValid)
        ? (_openBlock(), _createBlock("div", _hoisted_6, [
            _createVNode(_component_button_fill, {
              title: _ctx.$t('userManagement.add.save'),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onOpenSave())),
              class: "px-8 bg-red-lp-300"
            }, null, 8, ["title"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_7, [
      _createVNode("div", _hoisted_8, [
        _createVNode("div", _hoisted_9, [
          _createVNode("div", _hoisted_10, [
            _createVNode("div", _hoisted_11, _toDisplayString(_ctx.$t("userManagement.add.accountType")), 1),
            _createVNode(_component_Select, {
              id: "account-type-input",
              dataSelect: _ctx.typeData,
              onOpenSelect: _ctx.onOpenTypeSelect,
              onCloseSelect: _ctx.onCloseTypeSelect,
              onChooseSelect: _ctx.onSelectType,
              value: _ctx.typeName,
              isOpenMenu: _ctx.typeSelect,
              class: "w-full z-10"
            }, null, 8, ["dataSelect", "onOpenSelect", "onCloseSelect", "onChooseSelect", "value", "isOpenMenu"])
          ]),
          _withDirectives(_createVNode("div", _hoisted_12, [
            _createVNode("div", _hoisted_13, _toDisplayString(_ctx.$t("userManagement.add.division")), 1),
            _createVNode(_component_SelectSearch, {
              onFilter: _ctx.fetchListDivision,
              onFocus: _ctx.focusListDivision,
              isLoading: _ctx.loadingDivision,
              options: _ctx.divisionDataList,
              keyName: "name",
              keyValue: "value",
              placeholder: _ctx.$t('userManagement.add.selectDivision'),
              "model-value": _ctx.divisionName,
              "onUpdate:modelValue": _ctx.onSelectDivision,
              "is-disabled": _ctx.typeValue === '',
              isSelectedNotReset: true
            }, null, 8, ["onFilter", "onFocus", "isLoading", "options", "placeholder", "model-value", "onUpdate:modelValue", "is-disabled"])
          ], 512), [
            [_vShow, _ctx.typeName.match(/^Internal$/)]
          ]),
          _withDirectives(_createVNode("div", _hoisted_14, [
            _createVNode("div", _hoisted_15, _toDisplayString(_ctx.$t("userManagement.add.reference")), 1),
            _createVNode(_component_SelectSearch, {
              onFilter: _ctx.fetchListReference,
              onFocus: _ctx.focusListReference,
              isLoading: _ctx.loadingReference,
              options: _ctx.referenceDataList,
              keyName: "name",
              keyValue: "value",
              placeholder: _ctx.$t('userManagement.add.selectReference'),
              "model-value": _ctx.referenceName,
              "onUpdate:modelValue": _ctx.onSelectReference,
              "is-disabled": _ctx.typeValue === '',
              isSelectedNotReset: true
            }, null, 8, ["onFilter", "onFocus", "isLoading", "options", "placeholder", "model-value", "onUpdate:modelValue", "is-disabled"])
          ], 512), [
            [_vShow, !_ctx.typeName.match(/^Internal$|^Customer Service$/)]
          ]),
          _createVNode("div", _hoisted_16, [
            _createVNode("div", _hoisted_17, _toDisplayString(_ctx.$t("userManagement.add.role")), 1),
            _createVNode(_component_Select, {
              class: [[
              {
                'disabled-hub-field': _ctx.showRoleWithDivision
              }
            ], "w-full z-10"],
              dataSelect: _ctx.roleData,
              onOpenSelect: _ctx.onOpenRoleSelect,
              onCloseSelect: _ctx.onCloseRoleSelect,
              onChooseSelect: _ctx.onSelectRole,
              value: _ctx.roleName,
              isOpenMenu: _ctx.roleSelect,
              "is-disabled": _ctx.typeValue === '' || _ctx.showRoleWithDivision
            }, null, 8, ["class", "dataSelect", "onOpenSelect", "onCloseSelect", "onChooseSelect", "value", "isOpenMenu", "is-disabled"])
          ]),
          _withDirectives(_createVNode("div", _hoisted_18, [
            _createVNode("div", _hoisted_19, _toDisplayString(_ctx.$t("userManagement.add.hub")), 1),
            _createVNode(_component_SelectSearch, {
              class: [
              {
                'disabled-hub-field': _ctx.isReferenceEmptyHub
              }
            ],
              isLoading: _ctx.loadingHub,
              options: _ctx.listHubDataList,
              keyName: "name",
              keyValue: "value",
              placeholder: _ctx.$t('userManagement.add.selectHub'),
              "model-value": _ctx.hubName,
              "is-disabled": _ctx.typeValue === '' || _ctx.isReferenceEmptyHub,
              useInfiniteScroll: "",
              "onUpdate:modelValue": _ctx.onSelectHub,
              onScrolled: _ctx.fetchListHubInfiniteScroll,
              isSelectedNotReset: true
            }, null, 8, ["class", "isLoading", "options", "placeholder", "model-value", "is-disabled", "onUpdate:modelValue", "onScrolled"])
          ], 512), [
            [_vShow, _ctx.showHubNewField]
          ]),
          (
            _ctx.showShuttleFiled &&
              _ctx.typeName !== _ctx.selectLabel &&
              _ctx.typeName &&
              _ctx.typeName.match(/^Console$/) &&
              _ctx.shuttleDataList.length > 0
          )
            ? (_openBlock(), _createBlock("div", _hoisted_20, [
                _createVNode("div", _hoisted_21, _toDisplayString(_ctx.$t("userManagement.add.shuttleOptional")), 1),
                _createVNode(_component_SelectSearch, {
                  isLoading: _ctx.loadingShuttle,
                  options: _ctx.shuttleDataList,
                  keyName: "name",
                  keyValue: "value",
                  placeholder: _ctx.$t('userManagement.add.selectShuttle'),
                  "model-value": _ctx.shuttleName,
                  "onUpdate:modelValue": _ctx.onSelectShuttle,
                  "is-disabled": _ctx.typeValue === '',
                  isSelectedNotReset: true
                }, null, 8, ["isLoading", "options", "placeholder", "model-value", "onUpdate:modelValue", "is-disabled"])
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.isShowAssigned3Lc)
          ? (_openBlock(), _createBlock(_component_DataWrapper, {
              key: 0,
              label: _ctx.$t('userManagement.add.assignedTo3lc'),
              class: "w-full md:w-3/4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_MultipleSelectSearch, {
                  "modal-title": _ctx.$t('userManagement.add.modal3lcTitle'),
                  "option-name": "kota",
                  customDisplayAll: _ctx.$t('userManagement.add.all3lc'),
                  onFocus: _ctx.fetchCity,
                  onFilter: _ctx.filterCity,
                  options: _ctx.cityOptions,
                  modelValue: _ctx.assignTo,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.assignTo = $event)),
                  keyName: "name",
                  keyValue: "value",
                  placeholder: _ctx.$t('userManagement.add.searchOrSelect3lc'),
                  showReset: "",
                  onChange: _cache[4] || (_cache[4] = () => {}),
                  class: "mt-2",
                  "able-to-delete-in-modal": "",
                  useInfiniteScroll: "",
                  onScrolled: _ctx.fetchCityListInfiniteScroll,
                  id: "multiple-select-search_3LC_buat-user"
                }, null, 8, ["modal-title", "customDisplayAll", "onFocus", "onFilter", "options", "modelValue", "placeholder", "onScrolled"])
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_22, [
          _createVNode("div", _hoisted_23, _toDisplayString(_ctx.$t("userManagement.add.username")), 1),
          _createVNode("div", _hoisted_24, [
            _createVNode("div", _hoisted_25, [
              _createVNode("div", _hoisted_26, [
                _withDirectives(_createVNode("input", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.username = $event)),
                  type: "text",
                  onInput: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.validateUsername && _ctx.validateUsername(...args))),
                  onKeydown: _cache[7] || (_cache[7] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["space"])),
                  placeholder: _ctx.$t('userManagement.add.placeholderUsername'),
                  class: 
                  `py-1.5 xxl:py-3 px-4 rounded border ${!_ctx.validUsername &&
                    'border-red-lp-100 focus:border-red-lp-100 '} focus:outline-none focus:shadow my-1 text-black-lp-300 w-full ${_ctx.isDisabled &&
                    'bg-white'}`
                
                }, null, 42, ["placeholder"]), [
                  [_vModelText, _ctx.username]
                ]),
                _withDirectives(_createVNode("div", _hoisted_27, [
                  _hoisted_28
                ], 512), [
                  [_vShow, !_ctx.validUsername]
                ])
              ]),
              (_ctx.isConsoleAccountType)
                ? (_openBlock(), _createBlock("span", _hoisted_29, " cons." + _toDisplayString(_ctx.referenceName?.partnerCityCode?.toLowerCase()), 1))
                : _createCommentVNode("", true)
            ]),
            _withDirectives(_createVNode("span", { class: "text-red-lp-100" }, _toDisplayString(_ctx.$t("userManagement.add.usernameFormatInvalid")), 513), [
              [_vShow, !_ctx.validUsername]
            ]),
            _createVNode("ul", _hoisted_30, [
              _createVNode("li", null, _toDisplayString(_ctx.$t("userManagement.add.usernameRule1")), 1),
              _createVNode("li", null, [
                _createTextVNode(_toDisplayString(_ctx.$t("userManagement.add.usernameRule2")) + " ", 1),
                _createVNode("span", _hoisted_31, _toDisplayString(_ctx.convertUsername), 1)
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_32, [
          _createVNode("div", {
            class: ["w-full py-3 mr-4", _ctx.isInternalAccount ? 'md:w-1/3' : 'md:w-1/2']
          }, [
            _createVNode("div", _hoisted_33, _toDisplayString(_ctx.$t("userManagement.add.email")), 1),
            _createVNode("div", _hoisted_34, [
              _withDirectives(_createVNode("input", {
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.email = $event)),
                type: "text",
                onInput: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.validateEmail && _ctx.validateEmail(...args))),
                placeholder: "e.g email@gmail.com",
                class: 
                `focus:border-red-lp-100
            py-1.5 my-1.5 xxl:py-3 px-4 rounded border ${!_ctx.validEmail &&
              'border-red-lp-100'} focus:outline-none focus:shadow my-1
            text-black-lp-300 w-full ${_ctx.isDisabled && 'bg-white'}`
              
              }, null, 34), [
                [_vModelText, _ctx.email]
              ]),
              _withDirectives(_createVNode("div", _hoisted_35, [
                _hoisted_36
              ], 512), [
                [_vShow, !_ctx.validEmail]
              ])
            ]),
            (!_ctx.validEmail)
              ? (_openBlock(), _createBlock("span", _hoisted_37, _toDisplayString(_ctx.$t("userManagement.add.emailInvalid")), 1))
              : (_ctx.isWhitelistEmail)
                ? (_openBlock(), _createBlock("div", _hoisted_38, [
                    _createVNode("img", {
                      src: require('@/app/ui/assets/svg/warning-red.svg'),
                      style: {"width":"13px","height":"12px"},
                      alt: ""
                    }, null, 8, ["src"]),
                    _createVNode("span", _hoisted_39, _toDisplayString(_ctx.$t("userManagement.add.emailDomainInvalid")), 1)
                  ]))
                : _createCommentVNode("", true)
          ], 2),
          _createVNode("div", {
            class: ["w-full py-3", _ctx.isInternalAccount ? 'md:w-1/3 mr-4' : 'md:w-1/2']
          }, [
            _createVNode("div", _hoisted_40, _toDisplayString(_ctx.$t("userManagement.add.phoneNumber")), 1),
            _createVNode(_component_SelectPhoneCountry, {
              phone: _ctx.phoneNumber,
              code: _ctx.phoneNumberCode,
              placeholder: _ctx.$t('userManagement.add.placeholderPhone'),
              onSetPhone: _ctx.setPhoneNumber,
              onSetPhoneCode: _ctx.setPhoneCodeNumber
            }, null, 8, ["phone", "code", "placeholder", "onSetPhone", "onSetPhoneCode"])
          ], 2),
          (_ctx.isInternalAccount)
            ? (_openBlock(), _createBlock("div", _hoisted_41, [
                _hoisted_42,
                _createVNode(_component_SelectSearch, {
                  "data-testid": "user-management-add-hq-country-select",
                  class: "mt-1.5",
                  isLoading: _ctx.isLoadingHqCountry,
                  options: _ctx.hqCountryOptions,
                  keyName: "name",
                  keyValue: "value",
                  placeholder: "Pilih negara HQ",
                  "model-value": _ctx.hqCountry,
                  isSelectedNotReset: true,
                  onFocus: _cache[10] || (_cache[10] = ($event: any) => (_ctx.fetchHqCountries(''))),
                  onFilter: _ctx.fetchHqCountries,
                  "onUpdate:modelValue": _ctx.onSelectHqCountry
                }, {
                  "selected-prefix": _withCtx(({ selected }) => [
                    (selected?.flag)
                      ? (_openBlock(), _createBlock("img", {
                          key: 0,
                          class: "self-center w-4 mr-2",
                          alt: selected.flag,
                          src: selected.flag
                        }, null, 8, ["alt", "src"]))
                      : _createCommentVNode("", true)
                  ]),
                  "custom-option": _withCtx(({ item }) => [
                    _createVNode("button", _hoisted_43, [
                      (item.flag)
                        ? (_openBlock(), _createBlock("img", {
                            key: 0,
                            class: "self-center w-4",
                            alt: item.flag,
                            src: item.flag
                          }, null, 8, ["alt", "src"]))
                        : _createCommentVNode("", true),
                      _createVNode("span", _hoisted_44, _toDisplayString(item.name), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["isLoading", "options", "model-value", "onFilter", "onUpdate:modelValue"])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.onCloseSuccess,
      title: _ctx.$t('userManagement.add.modalSuccessTitle'),
      message: 
      _ctx.$t('userManagement.add.modalSuccessMessage', { name: _ctx.convertUsername })
    ,
      image: "image-modal-success",
      textSuccess: _ctx.$t('userManagement.add.ok'),
      class: "px-8"
    }, null, 8, ["onSubmit", "title", "message", "textSuccess"]), [
      [_vShow, _ctx.openSuccess]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.handlerClose,
      onClose: _ctx.handlerCancelClose,
      title: _ctx.$t('userManagement.add.confirmLeaveTitle'),
      message: _ctx.$t('userManagement.add.confirmLeaveMessage'),
      image: "are-you-sure",
      textSuccess: _ctx.$t('userManagement.add.leave'),
      textCancel: _ctx.$t('userManagement.add.back'),
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "title", "message", "textSuccess", "textCancel"]), [
      [_vShow, _ctx.isEditTerminated]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx._onCreate,
      onClose: _ctx.onCloseSave,
      title: _ctx.$t('userManagement.add.confirmCreateTitle'),
      message: 
      _ctx.$t('userManagement.add.confirmCreateMessage', { name: _ctx.convertUsername })
    ,
      image: "are-you-sure",
      textSuccess: _ctx.$t('userManagement.add.save'),
      textCancel: _ctx.$t('userManagement.add.back'),
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "title", "message", "textSuccess", "textCancel"]), [
      [_vShow, _ctx.openSave]
    ])
  ], 64))
}